<template>
  <!-- ======= srart Breadcrumbs ======= -->
  <section class="breadcrumbs py-4" data-aos="fade-up" data-aos-delay="100">
    <div class="container">
      <ol>
        <li><router-link to="/">Inicio</router-link></li>
        <li>Portafolio</li>
      </ol>
      <h2 class="title">Portafolio</h2>
      <p class="col-lg-10 col-12">Aquí nuestro portaforlio de productos desarrollados por nosotros.</p>
    </div>
  </section>
  <!-- End Breadcrumbs -->
  <div id="particles-js"></div>
  <!--Portfolio-->
  <portfolio-single-section></portfolio-single-section>
  <!-- FAQ Seection -->
  <faq-section></faq-section>
</template>